
import * as Li9za2lrby5tanM from './skiko.mjs';
import * as QGpzLWpvZGEvY29yZQ from '@js-joda/core';
import * as ZmlyZWJhc2UvYW5hbHl0aWNz from 'firebase/analytics';
import * as ZmlyZWJhc2UvYXBw from 'firebase/app';
import * as ZmlyZWJhc2UvYXV0aA from 'firebase/auth';
import * as ZmlyZWJhc2UvZmlyZXN0b3Jl from 'firebase/firestore';
import * as ZmlyZWJhc2UvZnVuY3Rpb25z from 'firebase/functions';
import * as ZmlyZWJhc2UvaW5zdGFsbGF0aW9ucw from 'firebase/installations';
import * as ZmlyZWJhc2UvbWVzc2FnaW5n from 'firebase/messaging';
import * as d2FzbTpqcy1zdHJpbmc from './Oriens-webApp.js-builtins.mjs';

const wasmJsTag = WebAssembly.JSTag;
const wasmTag = wasmJsTag ?? new WebAssembly.Tag({ parameters: ['externref'] });

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const _ref_Li9za2lrby5tanM_ = Li9za2lrby5tanM;
const _ref_Li9za2lrby5tanM_c2tpa29BcGk = Li9za2lrby5tanM.skikoApi;
const _ref_QGpzLWpvZGEvY29yZQ_ = QGpzLWpvZGEvY29yZQ;
const _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_ = ZmlyZWJhc2UvYW5hbHl0aWNz;
const _ref_ZmlyZWJhc2UvYXBw_ = ZmlyZWJhc2UvYXBw;
const _ref_ZmlyZWJhc2UvYXV0aA_ = ZmlyZWJhc2UvYXV0aA;
const _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_ = ZmlyZWJhc2UvZmlyZXN0b3Jl;
const _ref_ZmlyZWJhc2UvZnVuY3Rpb25z_ = ZmlyZWJhc2UvZnVuY3Rpb25z;
const _ref_ZmlyZWJhc2UvaW5zdGFsbGF0aW9ucw_ = ZmlyZWJhc2UvaW5zdGFsbGF0aW9ucw;
const _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_ = ZmlyZWJhc2UvbWVzc2FnaW5n;

const cachedJsObjects = new WeakMap();
function getCachedJsObject(ref, ifNotCached) {
    if (typeof ref !== 'object' && typeof ref !== 'function') return ifNotCached;
    const cached = cachedJsObjects.get(ref);
    if (cached !== void 0) return cached;
    cachedJsObjects.set(ref, ifNotCached);
    return ifNotCached;
}

const js_code = {
    'kotlin.createJsError' : (message, cause) => new Error(message, { cause }),
    'kotlin.wasm.internal.jsThrow' : wasmTag === wasmJsTag ? (e) => { throw e; } : () => {},
    'kotlin.wasm.internal.getJsEmptyString' : () => '',
    'kotlin.wasm.internal.externrefToBoolean' : (ref) => Boolean(ref),
    'kotlin.wasm.internal.externrefToDouble' : (ref) => Number(ref),
    'kotlin.wasm.internal.externrefToInt' : (ref) => Number(ref),
    'kotlin.wasm.internal.intToExternref' : (x) => x,
    'kotlin.wasm.internal.getJsTrue' : () => true,
    'kotlin.wasm.internal.getJsFalse' : () => false,
    'kotlin.wasm.internal.externrefToString' : (ref) => String(ref),
    'kotlin.wasm.internal.externrefEquals' : (lhs, rhs) => lhs === rhs,
    'kotlin.wasm.internal.externrefHashCode' : 
    (() => {
    const dataView = new DataView(new ArrayBuffer(8));
    function numberHashCode(obj) {
        if ((obj | 0) === obj) {
            return obj | 0;
        } else {
            dataView.setFloat64(0, obj, true);
            return (dataView.getInt32(0, true) * 31 | 0) + dataView.getInt32(4, true) | 0;
        }
    }

    const hashCodes = new WeakMap();
    function getObjectHashCode(obj) {
        const res = hashCodes.get(obj);
        if (res === undefined) {
            const POW_2_32 = 4294967296;
            const hash = (Math.random() * POW_2_32) | 0;
            hashCodes.set(obj, hash);
            return hash;
        }
        return res;
    }

    function getStringHashCode(str) {
        var hash = 0;
        for (var i = 0; i < str.length; i++) {
            var code  = str.charCodeAt(i);
            hash  = (hash * 31 + code) | 0;
        }
        return hash;
    }

    return (obj) => {
        if (obj == null) {
            return 0;
        }
        switch (typeof obj) {
            case "object":
            case "function":
                return getObjectHashCode(obj);
            case "number":
                return numberHashCode(obj);
            case "boolean":
                return obj ? 1231 : 1237;
            default:
                return getStringHashCode(String(obj)); 
        }
    }
    })(),
    'kotlin.wasm.internal.isNullish' : (ref) => ref == null,
    'kotlin.wasm.internal.kotlinUIntToJsNumberUnsafe' : (x) => x >>> 0,
    'kotlin.wasm.internal.kotlinULongToJsBigIntUnsafe' : (x) => x & 0xFFFFFFFFFFFFFFFFn,
    'kotlin.wasm.internal.newJsArray' : () => [],
    'kotlin.wasm.internal.jsArrayPush' : (array, element) => { array.push(element); },
    'kotlin.wasm.internal.getCachedJsObject_$external_fun' : (p0, p1) => getCachedJsObject(p0, p1),
    'kotlin.wasm.internal.utoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.utoa64_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa32_$external_fun' : (p0) => String(p0),
    'kotlin.wasm.internal.itoa64_$external_fun' : (p0) => String(p0),
    'kotlin.js.jsCatch' : (f) => { 
        let result = null;
        try { 
            f();
        } catch (e) {
           result = e;
        }
        return result;
         },
    'kotlin.js.__convertKotlinClosureToJsClosure_0' : (f, trampoline) => getCachedJsObject(f, () => trampoline(f, )),
    'kotlin.js.jsThrow' : (e) => { throw e; },
    'kotlin.io.printlnImpl' : (message) => console.log(message),
    'kotlin.js.jsArrayGet' : (array, index) => array[index],
    'kotlin.js.jsArraySet' : (array, index, value) => { array[index] = value },
    'kotlin.js.JsArray_$external_fun' : () => new Array(),
    'kotlin.js.length_$external_prop_getter' : (_this) => _this.length,
    'kotlin.js.stackPlaceHolder_js_code' : () => (''),
    'kotlin.js.message_$external_prop_getter' : (_this) => _this.message,
    'kotlin.js.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'kotlin.js.stack_$external_prop_getter' : (_this) => _this.stack,
    'kotlin.js.kotlinException_$external_prop_getter' : (_this) => _this.kotlinException,
    'kotlin.js.kotlinException_$external_prop_setter' : (_this, v) => _this.kotlinException = v,
    'kotlin.js.JsError_$external_class_instanceof' : (x) => x instanceof Error,
    'kotlin.js.JsString_$external_class_instanceof' : (x) => typeof x === 'string',
    'kotlin.js.JsString_$external_class_get' : () => JsString,
    'kotlin.js.then_$external_fun' : (_this, p0) => _this.then(p0),
    'kotlin.js.__convertKotlinClosureToJsClosure_1' : (f, trampoline) => getCachedJsObject(f, (p0) => trampoline(f, p0)),
    'kotlin.js.then_$external_fun_1' : (_this, p0, p1) => _this.then(p0, p1),
    'kotlin.js.catch_$external_fun' : (_this, p0) => _this.catch(p0),
    'kotlin.js.resolve_$external_fun' : (_this, p0) => _this.resolve(p0),
    'kotlin.js.Companion_$external_object_getInstance' : () => Promise,
    'kotlin.js.Promise_$external_class_instanceof' : (x) => x instanceof Promise,
    'kotlin.js.Promise_$external_class_get' : () => Promise,
    'kotlin.random.initialSeed' : () => ((Math.random() * Math.pow(2, 32)) | 0),
    'kotlin.wasm.internal.getJsClassName' : (jsKlass) => jsKlass.name,
    'kotlin.wasm.internal.instanceOf' : (ref, jsKlass) => ref instanceof jsKlass,
    'kotlin.wasm.internal.getConstructor' : (obj) => obj.constructor,
    'kotlin.time.Date_$external_fun' : () => new Date(),
    'kotlin.time.getTime_$external_fun' : (_this, ) => _this.getTime(),
    'kotlin.time.tryGetPerformance' : () => typeof globalThis !== 'undefined' && typeof globalThis.performance !== 'undefined' ? globalThis.performance : null,
    'kotlin.time.getPerformanceNow' : (performance) => performance.now(),
    'kotlin.time.dateNow' : () => Date.now(),
    'kotlin.uuid.cryptoGetRandomValues' : (size) => crypto.getRandomValues(new Int8Array(size)),
    'kotlin.uuid.get' : (array, index) => array[index],
    'kotlinx.coroutines.tryGetProcess' : () => (typeof(process) !== 'undefined' && typeof(process.nextTick) === 'function') ? process : null,
    'kotlinx.coroutines.tryGetWindow' : () => (typeof(window) !== 'undefined' && window != null && typeof(window.addEventListener) === 'function') ? window : null,
    'kotlinx.coroutines.nextTick_$external_fun' : (_this, p0) => _this.nextTick(p0),
    'kotlinx.coroutines.createScheduleMessagePoster' : (process) => () => Promise.resolve(0).then(process),
    'kotlinx.coroutines.__callJsClosure_(()->Unit)' : (f, ) => f(),
    'kotlinx.coroutines.createRescheduleMessagePoster' : (window) => () => window.postMessage('dispatchCoroutine', '*'),
    'kotlinx.coroutines.subscribeToWindowMessages' : (window, process) => {
        const handler = (event) => {
            if (event.source == window && event.data == 'dispatchCoroutine') {
                event.stopPropagation();
                process();
            }
        }
        window.addEventListener('message', handler, true);
    },
    'kotlinx.coroutines.setTimeout' : (window, handler, timeout) => window.setTimeout(handler, timeout),
    'kotlinx.coroutines.clearTimeout' : (handle) => { if (typeof clearTimeout !== 'undefined') clearTimeout(handle); },
    'kotlinx.coroutines.clearTimeout_$external_fun' : (_this, p0) => _this.clearTimeout(p0),
    'kotlinx.coroutines.setTimeout_$external_fun' : (p0, p1) => setTimeout(p0, p1),
    'kotlinx.coroutines.internal.throwAsyncJsError' : (message, className, stack) => { 
            var error = new Error();
            error.message = message;
            error.name = className;
            error.stack = stack;
            if (typeof globalThis.reportError === 'function') {
                // Up-to-date browsers and some non-browser JS runtimes (Deno, Bun)
                globalThis.reportError(error);
            } else {
                // Fallback for old browsers (pre-2022), Node.js
                setTimeout(function () { throw error }, 0);
            }
         },
    'org.khronos.webgl.getMethodImplForInt8Array' : (obj, index) => obj[index],
    'org.khronos.webgl.byteLength_$external_prop_getter' : (_this) => _this.byteLength,
    'org.khronos.webgl.Int8Array_$external_fun' : (p0, p1, p2, isDefault0, isDefault1) => new Int8Array(p0, isDefault0 ? undefined : p1, isDefault1 ? undefined : p2, ),
    'org.khronos.webgl.length_$external_prop_getter' : (_this) => _this.length,
    'org.khronos.webgl.getParameter_$external_fun' : (_this, p0) => _this.getParameter(p0),
    'org.khronos.webgl.SAMPLES_$external_prop_getter' : (_this) => _this.SAMPLES,
    'org.khronos.webgl.Companion_$external_object_getInstance' : () => WebGLRenderingContext,
    'org.w3c.dom.clipboard.clipboardData_$external_prop_getter' : (_this) => _this.clipboardData,
    'org.w3c.dom.clipboard.ClipboardEvent_$external_class_instanceof' : (x) => x instanceof ClipboardEvent,
    'org.w3c.dom.css.cssText_$external_prop_setter' : (_this, v) => _this.cssText = v,
    'org.w3c.dom.css.cursor_$external_prop_setter' : (_this, v) => _this.cursor = v,
    'org.w3c.dom.css.display_$external_prop_setter' : (_this, v) => _this.display = v,
    'org.w3c.dom.css.fontSize_$external_prop_getter' : (_this) => _this.fontSize,
    'org.w3c.dom.css.fontSize_$external_prop_setter' : (_this, v) => _this.fontSize = v,
    'org.w3c.dom.css.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.css.left_$external_prop_setter' : (_this, v) => _this.left = v,
    'org.w3c.dom.css.opacity_$external_prop_setter' : (_this, v) => _this.opacity = v,
    'org.w3c.dom.css.outline_$external_prop_setter' : (_this, v) => _this.outline = v,
    'org.w3c.dom.css.position_$external_prop_setter' : (_this, v) => _this.position = v,
    'org.w3c.dom.css.top_$external_prop_setter' : (_this, v) => _this.top = v,
    'org.w3c.dom.css.whiteSpace_$external_prop_setter' : (_this, v) => _this.whiteSpace = v,
    'org.w3c.dom.css.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.css.setProperty_$external_fun' : (_this, p0, p1, p2, isDefault0) => _this.setProperty(p0, p1, isDefault0 ? undefined : p2, ),
    'org.w3c.dom.css.style_$external_prop_getter' : (_this) => _this.style,
    'org.w3c.dom.events.type_$external_prop_getter' : (_this) => _this.type,
    'org.w3c.dom.events.target_$external_prop_getter' : (_this) => _this.target,
    'org.w3c.dom.events.cancelable_$external_prop_getter' : (_this) => _this.cancelable,
    'org.w3c.dom.events.timeStamp_$external_prop_getter' : (_this) => _this.timeStamp,
    'org.w3c.dom.events.preventDefault_$external_fun' : (_this, ) => _this.preventDefault(),
    'org.w3c.dom.events.Event_$external_class_instanceof' : (x) => x instanceof Event,
    'org.w3c.dom.events.Event_$external_class_get' : () => Event,
    'org.w3c.dom.events.deltaX_$external_prop_getter' : (_this) => _this.deltaX,
    'org.w3c.dom.events.deltaY_$external_prop_getter' : (_this) => _this.deltaY,
    'org.w3c.dom.events.deltaMode_$external_prop_getter' : (_this) => _this.deltaMode,
    'org.w3c.dom.events.DOM_DELTA_PIXEL_$external_prop_getter' : (_this) => _this.DOM_DELTA_PIXEL,
    'org.w3c.dom.events.DOM_DELTA_LINE_$external_prop_getter' : (_this) => _this.DOM_DELTA_LINE,
    'org.w3c.dom.events.DOM_DELTA_PAGE_$external_prop_getter' : (_this) => _this.DOM_DELTA_PAGE,
    'org.w3c.dom.events.Companion_$external_object_getInstance' : () => WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_instanceof' : (x) => x instanceof WheelEvent,
    'org.w3c.dom.events.WheelEvent_$external_class_get' : () => WheelEvent,
    'org.w3c.dom.events.key_$external_prop_getter' : (_this) => _this.key,
    'org.w3c.dom.events.code_$external_prop_getter' : (_this) => _this.code,
    'org.w3c.dom.events.ctrlKey_$external_prop_getter' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter' : (_this) => _this.metaKey,
    'org.w3c.dom.events.isComposing_$external_prop_getter' : (_this) => _this.isComposing,
    'org.w3c.dom.events.keyCode_$external_prop_getter' : (_this) => _this.keyCode,
    'org.w3c.dom.events.KeyboardEvent_$external_class_instanceof' : (x) => x instanceof KeyboardEvent,
    'org.w3c.dom.events.KeyboardEvent_$external_class_get' : () => KeyboardEvent,
    'org.w3c.dom.events.addEventListener_$external_fun' : (_this, p0, p1, p2) => _this.addEventListener(p0, p1, p2),
    'org.w3c.dom.events.addEventListener_$external_fun_1' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.addEventListener_$external_fun_2' : (_this, p0, p1) => _this.addEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun' : (_this, p0, p1, p2) => _this.removeEventListener(p0, p1, p2),
    'org.w3c.dom.events.removeEventListener_$external_fun_1' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.removeEventListener_$external_fun_2' : (_this, p0, p1) => _this.removeEventListener(p0, p1),
    'org.w3c.dom.events.ctrlKey_$external_prop_getter_1' : (_this) => _this.ctrlKey,
    'org.w3c.dom.events.shiftKey_$external_prop_getter_1' : (_this) => _this.shiftKey,
    'org.w3c.dom.events.altKey_$external_prop_getter_1' : (_this) => _this.altKey,
    'org.w3c.dom.events.metaKey_$external_prop_getter_1' : (_this) => _this.metaKey,
    'org.w3c.dom.events.button_$external_prop_getter' : (_this) => _this.button,
    'org.w3c.dom.events.buttons_$external_prop_getter' : (_this) => _this.buttons,
    'org.w3c.dom.events.offsetX_$external_prop_getter' : (_this) => _this.offsetX,
    'org.w3c.dom.events.offsetY_$external_prop_getter' : (_this) => _this.offsetY,
    'org.w3c.dom.events.isComposing_$external_prop_getter_1' : (_this) => _this.isComposing,
    'org.w3c.dom.events.InputEvent_$external_class_instanceof' : (x) => x instanceof InputEvent,
    'org.w3c.dom.events.InputEvent_$external_class_get' : () => InputEvent,
    'org.w3c.dom.events.data_$external_prop_getter' : (_this) => _this.data,
    'org.w3c.dom.events.CompositionEvent_$external_class_instanceof' : (x) => x instanceof CompositionEvent,
    'org.w3c.dom.events.CompositionEvent_$external_class_get' : () => CompositionEvent,
    'org.w3c.dom.events.relatedTarget_$external_prop_getter' : (_this) => _this.relatedTarget,
    'org.w3c.dom.events.FocusEvent_$external_class_instanceof' : (x) => x instanceof FocusEvent,
    'org.w3c.dom.events.FocusEvent_$external_class_get' : () => FocusEvent,
    'org.w3c.dom.ShadowRootInit' : (mode) => ({ mode: mode }),
    'org.w3c.dom.AddEventListenerOptions_js_code' : (passive, once, capture) => ({ passive: passive, once: once, capture: capture }),
    'org.w3c.dom.removeItem_$external_fun' : (_this, p0) => _this.removeItem(p0),
    'org.w3c.dom.getItem_$external_fun' : (_this, p0) => _this.getItem(p0),
    'org.w3c.dom.setItem_$external_fun' : (_this, p0, p1) => _this.setItem(p0, p1),
    'org.w3c.dom.location_$external_prop_getter' : (_this) => _this.location,
    'org.w3c.dom.navigator_$external_prop_getter' : (_this) => _this.navigator,
    'org.w3c.dom.innerWidth_$external_prop_getter' : (_this) => _this.innerWidth,
    'org.w3c.dom.innerHeight_$external_prop_getter' : (_this) => _this.innerHeight,
    'org.w3c.dom.devicePixelRatio_$external_prop_getter' : (_this) => _this.devicePixelRatio,
    'org.w3c.dom.requestAnimationFrame_$external_fun' : (_this, p0) => _this.requestAnimationFrame(p0),
    'org.w3c.dom.matchMedia_$external_fun' : (_this, p0) => _this.matchMedia(p0),
    'org.w3c.dom.getComputedStyle_$external_fun' : (_this, p0, p1, isDefault0) => _this.getComputedStyle(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.matches_$external_prop_getter' : (_this) => _this.matches,
    'org.w3c.dom.addListener_$external_fun' : (_this, p0) => _this.addListener(p0),
    'org.w3c.dom.removeListener_$external_fun' : (_this, p0) => _this.removeListener(p0),
    'org.w3c.dom.MediaQueryList_$external_class_instanceof' : (x) => x instanceof MediaQueryList,
    'org.w3c.dom.MediaQueryList_$external_class_get' : () => MediaQueryList,
    'org.w3c.dom.href_$external_prop_getter' : (_this) => _this.href,
    'org.w3c.dom.protocol_$external_prop_getter' : (_this) => _this.protocol,
    'org.w3c.dom.tabIndex_$external_prop_setter' : (_this, v) => _this.tabIndex = v,
    'org.w3c.dom.offsetWidth_$external_prop_getter' : (_this) => _this.offsetWidth,
    'org.w3c.dom.offsetHeight_$external_prop_getter' : (_this) => _this.offsetHeight,
    'org.w3c.dom.click_$external_fun' : (_this, ) => _this.click(),
    'org.w3c.dom.focus_$external_fun' : (_this, ) => _this.focus(),
    'org.w3c.dom.blur_$external_fun' : (_this, ) => _this.blur(),
    'org.w3c.dom.HTMLElement_$external_class_instanceof' : (x) => x instanceof HTMLElement,
    'org.w3c.dom.HTMLElement_$external_class_get' : () => HTMLElement,
    'org.w3c.dom.dropEffect_$external_prop_setter' : (_this, v) => _this.dropEffect = v,
    'org.w3c.dom.setDragImage_$external_fun' : (_this, p0, p1, p2) => _this.setDragImage(p0, p1, p2),
    'org.w3c.dom.getData_$external_fun' : (_this, p0) => _this.getData(p0),
    'org.w3c.dom.setData_$external_fun' : (_this, p0, p1) => _this.setData(p0, p1),
    'org.w3c.dom.documentElement_$external_prop_getter' : (_this) => _this.documentElement,
    'org.w3c.dom.readyState_$external_prop_getter' : (_this) => _this.readyState,
    'org.w3c.dom.body_$external_prop_getter' : (_this) => _this.body,
    'org.w3c.dom.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'org.w3c.dom.createElement_$external_fun' : (_this, p0, p1, isDefault0) => _this.createElement(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.createTextNode_$external_fun' : (_this, p0) => _this.createTextNode(p0),
    'org.w3c.dom.hasFocus_$external_fun' : (_this, ) => _this.hasFocus(),
    'org.w3c.dom.getElementById_$external_fun' : (_this, p0) => _this.getElementById(p0),
    'org.w3c.dom.namespaceURI_$external_prop_getter' : (_this) => _this.namespaceURI,
    'org.w3c.dom.localName_$external_prop_getter' : (_this) => _this.localName,
    'org.w3c.dom.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'org.w3c.dom.className_$external_prop_setter' : (_this, v) => _this.className = v,
    'org.w3c.dom.classList_$external_prop_getter' : (_this) => _this.classList,
    'org.w3c.dom.shadowRoot_$external_prop_getter' : (_this) => _this.shadowRoot,
    'org.w3c.dom.scrollTop_$external_prop_getter' : (_this) => _this.scrollTop,
    'org.w3c.dom.scrollTop_$external_prop_setter' : (_this, v) => _this.scrollTop = v,
    'org.w3c.dom.scrollLeft_$external_prop_getter' : (_this) => _this.scrollLeft,
    'org.w3c.dom.scrollLeft_$external_prop_setter' : (_this, v) => _this.scrollLeft = v,
    'org.w3c.dom.clientWidth_$external_prop_getter' : (_this) => _this.clientWidth,
    'org.w3c.dom.clientHeight_$external_prop_getter' : (_this) => _this.clientHeight,
    'org.w3c.dom.getAttribute_$external_fun' : (_this, p0) => _this.getAttribute(p0),
    'org.w3c.dom.getAttributeNS_$external_fun' : (_this, p0, p1) => _this.getAttributeNS(p0, p1),
    'org.w3c.dom.setAttribute_$external_fun' : (_this, p0, p1) => _this.setAttribute(p0, p1),
    'org.w3c.dom.removeAttribute_$external_fun' : (_this, p0) => _this.removeAttribute(p0),
    'org.w3c.dom.hasAttribute_$external_fun' : (_this, p0) => _this.hasAttribute(p0),
    'org.w3c.dom.attachShadow_$external_fun' : (_this, p0) => _this.attachShadow(p0),
    'org.w3c.dom.getBoundingClientRect_$external_fun' : (_this, ) => _this.getBoundingClientRect(),
    'org.w3c.dom.Element_$external_class_instanceof' : (x) => x instanceof Element,
    'org.w3c.dom.nodeName_$external_prop_getter' : (_this) => _this.nodeName,
    'org.w3c.dom.isConnected_$external_prop_getter' : (_this) => _this.isConnected,
    'org.w3c.dom.parentElement_$external_prop_getter' : (_this) => _this.parentElement,
    'org.w3c.dom.childNodes_$external_prop_getter' : (_this) => _this.childNodes,
    'org.w3c.dom.firstChild_$external_prop_getter' : (_this) => _this.firstChild,
    'org.w3c.dom.nextSibling_$external_prop_getter' : (_this) => _this.nextSibling,
    'org.w3c.dom.textContent_$external_prop_getter' : (_this) => _this.textContent,
    'org.w3c.dom.textContent_$external_prop_setter' : (_this, v) => _this.textContent = v,
    'org.w3c.dom.contains_$external_fun' : (_this, p0) => _this.contains(p0),
    'org.w3c.dom.lookupPrefix_$external_fun' : (_this, p0) => _this.lookupPrefix(p0),
    'org.w3c.dom.insertBefore_$external_fun' : (_this, p0, p1) => _this.insertBefore(p0, p1),
    'org.w3c.dom.appendChild_$external_fun' : (_this, p0) => _this.appendChild(p0),
    'org.w3c.dom.removeChild_$external_fun' : (_this, p0) => _this.removeChild(p0),
    'org.w3c.dom.width_$external_prop_getter' : (_this) => _this.width,
    'org.w3c.dom.width_$external_prop_setter' : (_this, v) => _this.width = v,
    'org.w3c.dom.height_$external_prop_getter' : (_this) => _this.height,
    'org.w3c.dom.height_$external_prop_setter' : (_this, v) => _this.height = v,
    'org.w3c.dom.HTMLCanvasElement_$external_class_instanceof' : (x) => x instanceof HTMLCanvasElement,
    'org.w3c.dom.HTMLCanvasElement_$external_class_get' : () => HTMLCanvasElement,
    'org.w3c.dom.HTMLDivElement_$external_class_instanceof' : (x) => x instanceof HTMLDivElement,
    'org.w3c.dom.HTMLDivElement_$external_class_get' : () => HTMLDivElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_instanceof' : (x) => x instanceof HTMLTextAreaElement,
    'org.w3c.dom.HTMLTextAreaElement_$external_class_get' : () => HTMLTextAreaElement,
    'org.w3c.dom.TouchEvent_$external_class_instanceof' : (x) => x instanceof TouchEvent,
    'org.w3c.dom.TouchEvent_$external_class_get' : () => TouchEvent,
    'org.w3c.dom.item_$external_fun' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.dataTransfer_$external_prop_getter' : (_this) => _this.dataTransfer,
    'org.w3c.dom.DragEvent_$external_class_instanceof' : (x) => x instanceof DragEvent,
    'org.w3c.dom.DragEvent_$external_class_get' : () => DragEvent,
    'org.w3c.dom.matches_$external_prop_getter_1' : (_this) => _this.matches,
    'org.w3c.dom.MediaQueryListEvent_$external_class_instanceof' : (x) => x instanceof MediaQueryListEvent,
    'org.w3c.dom.MediaQueryListEvent_$external_class_get' : () => MediaQueryListEvent,
    'org.w3c.dom.add_$external_fun' : (_this, p0) => _this.add(...p0),
    'org.w3c.dom.Worker_$external_fun' : (p0, p1, isDefault0) => new Worker(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.Worker_$external_class_instanceof' : (x) => x instanceof Worker,
    'org.w3c.dom.Worker_$external_class_get' : () => Worker,
    'org.w3c.dom.userAgent_$external_prop_getter' : (_this) => _this.userAgent,
    'org.w3c.dom.language_$external_prop_getter' : (_this) => _this.language,
    'org.w3c.dom.caches_$external_prop_getter' : (_this) => _this.caches,
    'org.w3c.dom.fetch_$external_fun' : (_this, p0, p1, isDefault0) => _this.fetch(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.dom.children_$external_prop_getter' : (_this) => _this.children,
    'org.w3c.dom.firstElementChild_$external_prop_getter' : (_this) => _this.firstElementChild,
    'org.w3c.dom.lastElementChild_$external_prop_getter' : (_this) => _this.lastElementChild,
    'org.w3c.dom.Companion_$external_object_getInstance' : () => ({}),
    'org.w3c.dom.item_$external_fun_1' : (_this, p0) => _this.item(p0),
    'org.w3c.dom.top_$external_prop_getter' : (_this) => _this.top,
    'org.w3c.dom.right_$external_prop_getter' : (_this) => _this.right,
    'org.w3c.dom.bottom_$external_prop_getter' : (_this) => _this.bottom,
    'org.w3c.dom.left_$external_prop_getter' : (_this) => _this.left,
    'org.w3c.dom.nextElementSibling_$external_prop_getter' : (_this) => _this.nextElementSibling,
    'org.w3c.dom.remove_$external_fun' : (_this, ) => _this.remove(),
    'org.w3c.dom.Companion_$external_object_getInstance_1' : () => ({}),
    'org.w3c.dom.parsing.DOMParser_$external_fun' : () => new DOMParser(),
    'org.w3c.dom.parsing.parseFromString_$external_fun' : (_this, p0, p1) => _this.parseFromString(p0, p1),
    'org.w3c.dom.pointerevents.pointerId_$external_prop_getter' : (_this) => _this.pointerId,
    'org.w3c.dom.pointerevents.pressure_$external_prop_getter' : (_this) => _this.pressure,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_instanceof' : (x) => x instanceof PointerEvent,
    'org.w3c.dom.pointerevents.PointerEvent_$external_class_get' : () => PointerEvent,
    'org.w3c.dom.url.createObjectURL_$external_fun' : (_this, p0) => _this.createObjectURL(p0),
    'org.w3c.dom.url.revokeObjectURL_$external_fun' : (_this, p0) => _this.revokeObjectURL(p0),
    'org.w3c.dom.url.Companion_$external_object_getInstance' : () => URL,
    'org.w3c.fetch.ok_$external_prop_getter' : (_this) => _this.ok,
    'org.w3c.fetch.clone_$external_fun' : (_this, ) => _this.clone(),
    'org.w3c.fetch.arrayBuffer_$external_fun' : (_this, ) => _this.arrayBuffer(),
    'org.w3c.fetch.blob_$external_fun' : (_this, ) => _this.blob(),
    'org.w3c.fetch.Response_$external_class_instanceof' : (x) => x instanceof Response,
    'org.w3c.fetch.Response_$external_class_get' : () => Response,
    'org.w3c.files.slice_$external_fun' : (_this, p0, p1, p2, isDefault0, isDefault1, isDefault2) => _this.slice(isDefault0 ? undefined : p0, isDefault1 ? undefined : p1, isDefault2 ? undefined : p2, ),
    'org.w3c.performance.now_$external_fun' : (_this, ) => _this.now(),
    'org.w3c.performance.performance_$external_prop_getter' : (_this) => _this.performance,
    'org.w3c.workers.CacheQueryOptions_js_code' : (ignoreSearch, ignoreMethod, ignoreVary, cacheName) => ({ ignoreSearch: ignoreSearch, ignoreMethod: ignoreMethod, ignoreVary: ignoreVary, cacheName: cacheName }),
    'org.w3c.workers.match_$external_fun' : (_this, p0, p1, isDefault0) => _this.match(p0, isDefault0 ? undefined : p1, ),
    'org.w3c.workers.put_$external_fun' : (_this, p0, p1) => _this.put(p0, p1),
    'org.w3c.workers.open_$external_fun' : (_this, p0) => _this.open(p0),
    'org.w3c.workers.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'kotlinx.browser.sessionStorage_$external_prop_getter' : () => sessionStorage,
    'kotlinx.browser.localStorage_$external_prop_getter' : () => localStorage,
    'kotlinx.browser.window_$external_prop_getter' : () => window,
    'kotlinx.browser.document_$external_prop_getter' : () => document,
    'org.w3c.dom.length_$external_prop_getter' : (_this) => _this.length,
    'androidx.compose.runtime.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.runtime.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.runtime.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.runtime.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.runtime.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'org.jetbrains.skiko.GL_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.GL,
    'org.jetbrains.skia.impl.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'org.jetbrains.skia.impl.register_$external_fun' : (_this, p0, p1, p2) => _this.register(p0, p1, p2),
    'org.jetbrains.skia.impl.unregister_$external_fun' : (_this, p0) => _this.unregister(p0),
    'org.jetbrains.skia.impl._releaseLocalCallbackScope_$external_fun' : () => _ref_Li9za2lrby5tanM_c2tpa29BcGk._releaseLocalCallbackScope(),
    'org.jetbrains.skiko.wasm.awaitSkiko_$external_prop_getter' : () => _ref_Li9za2lrby5tanM_.awaitSkiko,
    'org.jetbrains.skiko.currentNanoTimeWindowPerformance' : () => window.performance.now() * 1000000,
    'org.jetbrains.skiko.currentGLContext' : (gl) => gl.currentContext ? gl.currentContext.GLctx : null,
    'org.jetbrains.skiko.windowRequestAnimationFrame' : (callback) => window.requestAnimationFrame(callback),
    'org.jetbrains.skiko.createContext_$external_fun' : (_this, p0, p1) => _this.createContext(p0, p1),
    'org.jetbrains.skiko.makeContextCurrent_$external_fun' : (_this, p0) => _this.makeContextCurrent(p0),
    'org.jetbrains.skiko.getNavigatorInfo' : () => navigator.userAgentData ? navigator.userAgentData.platform : navigator.platform,
    'org.jetbrains.skiko.defaultFetchInit_js_code' : () => ({}),
    'org.jetbrains.skiko.jsCatch' : function (f) { try { f(); } catch (e) { return e;}; return null; },
    'org.jetbrains.skiko.jsThrow' : (e) => { throw e; },
    'org.jetbrains.skiko.wasm.patchWebGlContext' : (canvas) => {
        if (!canvas.getContext.webGlContextPatched) {
            var oldGetContext = canvas.getContext;
            canvas.getContext = function() {
                var gl = oldGetContext.apply(this, arguments);
                if (gl && !gl.webGlContextPatched) {
                    var oldGetSupportedExtensions = gl.getSupportedExtensions;
                    if (typeof oldGetSupportedExtensions === 'function') {
                        gl.getSupportedExtensions = function() {
                            var exts = oldGetSupportedExtensions.apply(this, arguments);
                            if (exts && exts.filter) {
                                return exts.filter(function(name) {
                                    return name !== 'WEBGL_debug_renderer_info' && name !== 'WEBGL_polygon_mode';
                                });
                            }
                            return exts;
                        };
                    }
                    var oldGetExtension = gl.getExtension;
                    if (typeof oldGetExtension === 'function') {
                        gl.getExtension = function(name) {
                            if (name === 'WEBGL_debug_renderer_info' || name === 'WEBGL_polygon_mode') {
                                return null;
                            }
                            return oldGetExtension.apply(this, arguments);
                        };
                    }
                    var oldGetParameter = gl.getParameter;
                    if (typeof oldGetParameter === 'function') {
                        gl.getParameter = function(pname) {
                            // 0x9245 = UNMASKED_VENDOR_WEBGL, 0x9246 = UNMASKED_RENDERER_WEBGL;
                            // both belong to WEBGL_debug_renderer_info, so hide them to avoid the INVALID_ENUM warning
                            if (pname === 0x9245 || pname === 0x9246) {
                                return "";
                            }
                            // 0x0C02 = READ_BUFFER;
                            // hide to avoid "The READ_BUFFER attachment is multisampled" warning in Firefox
                            if (pname === 0x0C02) {
                                var fbo = oldGetParameter.apply(this, [0x8CAA]); // 0x8CAA = READ_FRAMEBUFFER_BINDING
                                return fbo ? 0x8CE0 : 0x0405; // 0x8CE0 = COLOR_ATTACHMENT0, 0x0405 = BACK
                            }
                            return oldGetParameter.apply(this, arguments);
                        };
                    }
                    gl.webGlContextPatched = true;
                }
                return gl;
            };
            canvas.getContext.webGlContextPatched = true;
        }
    },
    'org.jetbrains.skiko.wasm.contextAttributesWithDefaults' : (attr) => ({
            alpha: attr && attr.alpha != null ? attr.alpha : 1,
            depth: attr && attr.depth != null ? attr.depth : 1,
            stencil: attr && attr.stencil != null ? attr.stencil : 8,
            antialias: attr && attr.antialias != null ? attr.antialias : 0,
            premultipliedAlpha: attr && attr.premultipliedAlpha != null ? attr.premultipliedAlpha : 1,
            preserveDrawingBuffer: attr && attr.preserveDrawingBuffer != null ? attr.preserveDrawingBuffer : 0,
            powerPreference: ['default', 'low-power', 'high-performance'][
                attr && attr.powerPreference != null ? attr.powerPreference : 0
            ],
            failIfMajorPerformanceCaveat: attr && attr.failIfMajorPerformanceCaveat != null ? attr.failIfMajorPerformanceCaveat : 0,
            majorVersion: attr && attr.majorVersion != null ? attr.majorVersion : 2,
            enableExtensionsByDefault: attr && attr.enableExtensionsByDefault != null ? attr.enableExtensionsByDefault : 1,
            explicitSwapControl: attr && attr.explicitSwapControl != null ? attr.explicitSwapControl : 0,
            renderViaOffscreenBackBuffer: attr && attr.renderViaOffscreenBackBuffer != null ? attr.renderViaOffscreenBackBuffer : 0,
            desynchronized: attr && attr.desynchronized != null ? attr.desynchronized : 0,
        }),
    'androidx.lifecycle.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.lifecycle.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.text.intl.parseLanguageTagToIntlLocale' : (languageTag) => new Intl.Locale(languageTag),
    'androidx.compose.ui.text.intl.addLanguageChangeListener' : (listener) => { window.addEventListener('languagechange', listener) },
    'androidx.compose.ui.text.intl.getUserPreferredLanguagesAsArray' : () => window.navigator.languages,
    'androidx.compose.ui.text.intl._language_$external_prop_getter' : (_this) => _this.language,
    'androidx.compose.ui.text.intl._script_$external_prop_getter' : (_this) => _this.script,
    'androidx.compose.ui.text.intl._region_$external_prop_getter' : (_this) => _this.region,
    'androidx.compose.ui.text.intl._baseName_$external_prop_getter' : (_this) => _this.baseName,
    'androidx.compose.ui.text.FinalizationRegistry_$external_fun' : (p0) => new FinalizationRegistry(p0),
    'androidx.compose.ui.text.register_$external_fun' : (_this, p0, p1) => _this.register(p0, p1),
    'androidx.compose.ui.text.WeakRef_$external_fun_1' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.text.deref_$external_fun_1' : (_this, ) => _this.deref(),
    'androidx.compose.ui.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.ui.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.platform.createClipboardItemWithPlainText' : (text) => [new ClipboardItem({'text/plain': new Blob([text], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.emptyClipboardItems' : () => [new ClipboardItem({'text/plain': new Blob([''], { type: 'text/plain' })})],
    'androidx.compose.ui.platform.invalidClipboardItems' : () => [],
    'androidx.compose.ui.platform.warn' : (text) => { console.warn(text) },
    'androidx.compose.ui.events.withSignal' : (signal) => ({signal: signal}),
    'androidx.compose.ui.events.withSignalAndPassive' : (signal, passive) => ({signal: signal, passive: passive}),
    'androidx.compose.ui.events.AbortController_$external_fun' : () => new AbortController(),
    'androidx.compose.ui.events.signal_$external_prop_getter' : (_this) => _this.signal,
    'androidx.compose.ui.events.abort_$external_fun' : (_this, ) => _this.abort(),
    'androidx.compose.ui.internal.focusExt' : (element, _preventScroll) => element.focus({ preventScroll: _preventScroll }),
    'androidx.compose.ui.node.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.compose.ui.node.deref_$external_fun' : (_this, ) => _this.deref(),
    'androidx.compose.ui.platform.setBackingInputBox' : (container, left, top, width, height) => { 
        container.style.setProperty("--compose-internal-web-backing-input-left", left);
        container.style.setProperty("--compose-internal-web-backing-input-top", top);
        container.style.setProperty("--compose-internal-web-backing-input-width", width);
        container.style.setProperty("--compose-internal-web-backing-input-height", height)
     },
    'androidx.compose.ui.platform.isVibrationSupported' : () => 
            typeof window !== 'undefined' &&
            window.navigator != null &&
            typeof window.navigator.vibrate === 'function'
        ,
    'androidx.compose.ui.platform.vibrate' : (pattern) => { window.navigator.vibrate(pattern) },
    'androidx.compose.ui.platform.getSelectionRange' : (element) => {
            var selection = window.getSelection();
            if (selection == null) return null;
            var root = element.getRootNode();
            if (root == null) return null;

            if (typeof selection.getComposedRanges === 'function') {
                try {
                    // The modern standard approach
                    var composedRanges = selection.getComposedRanges({ shadowRoots: [root] });
                    if (composedRanges.length > 0) {
                        return composedRanges[0];
                    }
                    return null;
                } catch (e) {
                    // Fallback for early Safari 17 point-releases
                    var composedRanges = selection.getComposedRanges(root);
                    if (composedRanges.length > 0) {
                        return composedRanges[0];
                    }
                    return null;
                }
            }

            if (typeof root.getSelection === 'function') {
                var rootSelection = root.getSelection();
                if (rootSelection == null) return [0, 0];
                if (rootSelection.rangeCount > 0) {
                    return rootSelection.getRangeAt(0);
                }
                return null;
            }

            if (selection.rangeCount > 0) {
                return selection.getRangeAt(0);
            }
            return null;
        },
    'androidx.compose.ui.platform.computeSelectionOffset' : (container, offset) => {          
        // container.nodeType stands for textNodes                   
        if (container.nodeType == 3) return offset;
        var chars = 0;
        var n = Math.min(offset, container.childNodes.length);
        for (var i = 0; i < n; i++) {
            var c = container.childNodes[i];
            chars += (c.nodeType == 3)
                ? c.nodeValue.length
                : ((c.textContent && c.textContent.length) || 0);
        }
        return chars;
        },
    'androidx.compose.ui.platform.isTypedEvent' : (evt) => !evt.metaKey && !evt.ctrlKey && evt.key.charAt(0) === evt.key,
    'androidx.compose.ui.platform.data_$external_prop_getter' : (_this) => _this.data,
    'androidx.compose.ui.platform.inputType_$external_prop_getter' : (_this) => _this.inputType,
    'androidx.compose.ui.platform.firstRange_$external_prop_getter' : (_this) => _this.firstRange,
    'androidx.compose.ui.platform.firstRange_$external_prop_setter' : (_this, v) => _this.firstRange = v,
    'androidx.compose.ui.platform.getTargetRanges_$external_fun' : (_this, ) => _this.getTargetRanges(),
    'androidx.compose.ui.platform.startContainer_$external_prop_getter' : (_this) => _this.startContainer,
    'androidx.compose.ui.platform.startOffset_$external_prop_getter' : (_this) => _this.startOffset,
    'androidx.compose.ui.platform.endContainer_$external_prop_getter' : (_this) => _this.endContainer,
    'androidx.compose.ui.platform.endOffset_$external_prop_getter' : (_this) => _this.endOffset,
    'androidx.compose.ui.platform.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.platform.getRootNode_$external_fun' : (_this, ) => _this.getRootNode(),
    'androidx.compose.ui.platform.setBaseAndExtent_$external_fun' : (_this, p0, p1, p2, p3) => _this.setBaseAndExtent(p0, p1, p2, p3),
    'androidx.compose.ui.platform.getSelection_$external_fun' : (_this, ) => _this.getSelection(),
    'androidx.compose.ui.platform.getW3CClipboard' : () => window.navigator.clipboard,
    'androidx.compose.ui.platform.isSecureContext' : () => window.isSecureContext === true,
    'androidx.compose.ui.platform.isFullClipboardApiSupported' : () => Boolean(
            window.navigator.clipboard && 
            window.navigator.clipboard.write && 
            window.navigator.clipboard.read && 
            typeof(ClipboardItem) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.isFallbackWriteTextApiAvailable' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.writeText),
    'androidx.compose.ui.platform.types_$external_prop_getter' : (_this) => _this.types,
    'androidx.compose.ui.platform.getType_$external_fun' : (_this, p0) => _this.getType(p0),
    'androidx.compose.ui.platform.read_$external_fun' : (_this, ) => _this.read(),
    'androidx.compose.ui.platform.write_$external_fun' : (_this, p0) => _this.write(p0),
    'androidx.compose.ui.platform.writeText_$external_fun' : (_this, p0) => _this.writeText(p0),
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_instanceof' : (x) => x instanceof Clipboard,
    'androidx.compose.ui.platform.W3CTemporaryClipboard_$external_class_get' : () => Clipboard,
    'androidx.compose.ui.platform.isSchedulerApiSupported' : () => Boolean('scheduler' in window),
    'androidx.compose.ui.platform.schedulerPostTask' : (block) => scheduler.postTask(block, { priority: 'user-blocking',}),
    'androidx.compose.ui.platform.isIdleApiSupported' : () => Boolean('requestIdleCallback' in window),
    'androidx.compose.ui.platform.requestIdleCallback' : (callback) => window.requestIdleCallback(callback),
    'androidx.compose.ui.platform.cancelIdleCallback' : (handle) => { window.cancelIdleCallback(handle) },
    'androidx.compose.ui.platform.timeRemaining_$external_fun' : (_this, ) => _this.timeRemaining(),
    'androidx.compose.ui.platform.didTimeout_$external_prop_getter' : (_this) => _this.didTimeout,
    'androidx.compose.ui.platform.isFullWakeLockApiSupported' : () => Boolean(
            window.navigator.wakeLock && 
            typeof(WakeLockSentinel) !== 'undefined'
            )
        ,
    'androidx.compose.ui.platform.hasVirtualKeyboard' : () => ('virtualKeyboard' in navigator),
    'androidx.compose.ui.platform.installSafeAreaCssProperties' : () => (function() {
            let s = document.documentElement.style;
            s.setProperty('--cmp-safe-top', 'env(safe-area-inset-top, 0px)');
            s.setProperty('--cmp-safe-right', 'env(safe-area-inset-right, 0px)');
            s.setProperty('--cmp-safe-bottom', 'env(safe-area-inset-bottom, 0px)');
            s.setProperty('--cmp-safe-left', 'env(safe-area-inset-left, 0px)');
        })(),
    'androidx.compose.ui.platform.enableVirtualKeyboardOverlay' : () => (navigator.virtualKeyboard.overlaysContent = true),
    'androidx.compose.ui.platform.getVirtualKeyboard' : () => navigator.virtualKeyboard,
    'androidx.compose.ui.platform.getVisualViewport' : () => (window.visualViewport || null),
    'androidx.compose.ui.platform.readCssVarLeft' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-left')) || 0),
    'androidx.compose.ui.platform.readCssVarTop' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-top')) || 0),
    'androidx.compose.ui.platform.readCssVarRight' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-right')) || 0),
    'androidx.compose.ui.platform.readCssVarBottom' : () => (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--cmp-safe-bottom')) || 0),
    'androidx.compose.ui.platform.readVirtualKeyboardHeight' : () => (navigator.virtualKeyboard.boundingRect.height || 0),
    'androidx.compose.ui.platform.readVisualViewportImeHeight' : () => (function() {
        let vv = window.visualViewport;
        if (!vv) return 0;
        return Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
    })(),
    'androidx.compose.ui.platform.accessibility.setA11YAriaRole' : (element, ariaRoleId) => { 
            var roleValue = "";
            switch (ariaRoleId) {
                case 0: // Role.Button
                    roleValue = "button";
                    break;
                case 1: // Role.Checkbox
                    roleValue = "checkbox";
                    break;
                case 2: // Role.Switch
                    roleValue = "switch";
                    break;
                case 3: // Role.RadioButton
                    roleValue = "radio";
                    break;
                case 4: // Role.Tab
                    roleValue = "tab";
                    break;
                case 5: // Role.Image
                    roleValue = "img";
                    break;
                case 6: // Role.DropdownList
                    roleValue = "menu";
                    break;
                case 7: // heading https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/heading_role
                    roleValue = "heading";
                    break;
                case 8: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/textbox_role
                    roleValue = "textbox";
                    break;
                case 9: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/list_role
                    roleValue = "list";
                    break;
                case 10: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/grid_role
                    roleValue = "grid";
                    break;
                case 11: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/dialog_role
                    roleValue = "dialog";
                    break;
                case 12: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/link_role
                    roleValue = "link";
                    break;
                case 13: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/progressbar_role
                    roleValue = "progressbar";
                    break;
                case 14: // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Reference/Roles/slider_role
                    roleValue = "slider";
                    break;
                default:
                    break;
            }
            if (roleValue.length > 0) { 
                element.setAttribute("role", roleValue);
            } else {
                element.removeAttribute("role");
            }
         },
    'androidx.compose.ui.platform.accessibility.setSizeAndPosition' : (element, left, top, width, height) => { 
           const leftValue = "" + left + "px";
           const topValue = "" + top + "px";
           const widthValue = "" + width + "px";
           const heightValue = "" + height + "px";

           if (element.style.left !== leftValue) {
               element.style.left = leftValue;
           }
           if (element.style.top !== topValue) {
               element.style.top = topValue;
           }
           if (element.style.width !== widthValue) {
               element.style.width = widthValue;
           }
           if (element.style.height !== heightValue) {
               element.style.height = heightValue;
           }
         },
    'androidx.compose.ui.platform.accessibility.removeAllChildrenOf' : (element) => { element.replaceChildren() },
    'androidx.compose.ui.platform.accessibility.toggleAttribute_$external_fun' : (_this, p0, p1) => _this.toggleAttribute(p0, p1),
    'androidx.compose.ui.platform.accessibility.setScrollContainerStyle' : (element, horizontal, vertical) => { 
            element.style.overflowX = horizontal ? "scroll" : "hidden";
            element.style.overflowY = vertical ? "scroll" : "hidden";
            element.style.scrollbarWidth = "none";
             },
    'androidx.compose.ui.platform.accessibility.resetScrollContainerStyle' : (element) => { 
            element.style.overflowX = "";
            element.style.overflowY = "";
            element.style.scrollbarWidth = "";
             },
    'androidx.compose.ui.viewinterop.getFocusableHtmlElement_js_code' : (container, last) => 
    (() => {
        if (!container) return null;

        // A flag to avoid redundant closest(inert) checks during upwards traversal when no inert nested elements are present
        const skipClosestInertCheck = last && !container.querySelector('[inert]');

        const selector = ':is(button, select, textarea, input:not([type="hidden"])):not([disabled]), [href], [tabindex]:not([tabindex="-1"]), [contenteditable]:not([contenteditable="false"]), summary, iframe, :is(audio, video)[controls]';
        const filter = {
            acceptNode(node) {
                if (node.inert) return NodeFilter.FILTER_REJECT; // completely skip an inert subtree
                if (node.matches(selector) && (skipClosestInertCheck || !node.closest('[inert]'))) return NodeFilter.FILTER_ACCEPT;
                return NodeFilter.FILTER_SKIP;
            }
        };

        if (!last) {
            const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, filter);
            return walker.nextNode();
        }

        // Reverse traversal — jump to the deepest last leaf, then walk backward
        let lastLeaf = container;
        while (lastLeaf.lastElementChild) {
            lastLeaf = lastLeaf.lastElementChild;
        }
        if (lastLeaf === container) return null;

        // If the last leaf itself is focusable, return it immediately
        if (filter.acceptNode(lastLeaf) === NodeFilter.FILTER_ACCEPT) {
            return lastLeaf;
        }

        // Position TreeWalker at the leaf and walk backward natively
        const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, filter);
        walker.currentNode = lastLeaf;
        return walker.previousNode();
    })(),
    'androidx.compose.ui.viewinterop.toggleVisibility' : (element, isHidden) => { 
           element.style.visibility = isHidden ? "hidden" : "visible";
         },
    'androidx.compose.ui.viewinterop.setSizeAndPosition' : (element, left, top, width, height) => { 
           element.style.left = "" + left + "px";
           element.style.top = "" + top + "px";
           element.style.width = "" + width + "px";
           element.style.height = "" + height + "px";
         },
    'androidx.compose.ui.viewinterop.setClipPath' : (element, top, right, bottom, left) => { 
           element.style.setProperty("clip-path", "inset(" + top + "px " + right + "px " + bottom + "px " + left + "px)"); 
         },
    'androidx.compose.ui.window.clearNodeChildren' : (node) => 
            {
                if (node.hasChildNodes()) node.replaceChildren();
            }
        ,
    'androidx.compose.ui.window.isWebGL2Supported' : () => !!document.createElement('canvas').getContext('webgl2'),
    'androidx.compose.ui.window.documentIsVisible' : () => document.visibilityState === 'visible',
    'androidx.compose.ui.window.checkViewportFitCover' : () => (function() {
            let meta = document.querySelector('meta[name=viewport]');
            let content = meta ? (meta.getAttribute('content') || '') : '';
            if (!content.includes('viewport-fit=cover')) {
                console.warn(
                    "[ComposeWeb] enableBrowserWindowInsets is set to true, but " +
                    "'viewport-fit=cover' is not found in the viewport meta tag. " +
                    "Safe area insets will be zero. Add viewport-fit=cover to your viewport meta tag: " +
                    "<meta name=\"viewport\" content=\"width=device-width, initial-scale=1, viewport-fit=cover\">"
                );
            }
        })(),
    'androidx.compose.ui.window.getVisualViewportScale' : () => window.visualViewport.scale,
    'androidx.compose.ui.window.isTouchEvent' : (event) => event.pointerType === 'touch',
    'androidx.compose.ui.window.releasePointerCapture' : (target, pointerId) => { try { target.releasePointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.isMouseEvent' : (event) => event.pointerType === 'mouse',
    'androidx.compose.ui.window.setPointerCapture' : (target, pointerId) => { try { target.setPointerCapture(pointerId) } catch (e) {} },
    'androidx.compose.ui.window.getCoalescedEvents' : (pointerEvent) => pointerEvent.getCoalescedEvents ? pointerEvent.getCoalescedEvents() : [],
    'androidx.compose.ui.window.composeComponentElementCtor' : (weakMap) => 
        (() => {
            class ComposeComponentElement extends HTMLElement {
                disconnectedCallback() {
                    const cb = weakMap.get(this);
                    if (cb) cb();
                }
            }
            return ComposeComponentElement;
        })()
    ,
    'androidx.compose.ui.window.clientXOf' : (event) => event.clientX,
    'androidx.compose.ui.window.clientYOf' : (event) => event.clientY,
    'androidx.compose.ui.window.getPointerEventCode' : (event) => {
            switch (event.type) {
              case 'pointerdown':
                return 1; // PointerEventType.Press
              case 'pointerup':
                return 2; // PointerEventType.Release
              case 'pointermove':
                return 3; // PointerEventType.Move
              case 'pointerenter':
                return 4; //PointerEventType.Enter
              case 'pointerleave':
                return 5; //PointerEventType.Exit
              default:
                return 0; // PointerEventType.Unknown
            } 
        },
    'androidx.compose.ui.window.getVisualViewport' : () => window.visualViewport,
    'androidx.compose.ui.window.activeElement_$external_prop_getter' : (_this) => _this.activeElement,
    'androidx.compose.ui.window.WeakMap_$external_fun' : () => new WeakMap(),
    'androidx.compose.ui.window.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.ui.window.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'androidx.compose.ui.window.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.compose.ui.window.define_$external_fun' : (_this, p0, p1) => _this.define(p0, p1),
    'androidx.compose.ui.window.customElements_$external_prop_getter' : () => customElements,
    'androidx.compose.ui.window.isMatchMediaSupported' : () => window.matchMedia != undefined,
    'androidx.compose.foundation.internal.isClipboardWriteSupported' : () => Boolean(window.navigator.clipboard && (window.navigator.clipboard.write || window.navigator.clipboard.writeText)),
    'androidx.compose.foundation.internal.isClipboardReadSupported' : () => Boolean(window.navigator.clipboard && window.navigator.clipboard.read),
    'androidx.compose.foundation.internal.getTextFromBlob' : (blob) => blob.text(),
    'androidx.compose.foundation.internal.doesJsArrayContainValue' : (jsArray, value) => jsArray.includes(value),
    'androidx.compose.foundation.text.EventListener' : (handler) => (event) => { handler(event) },
    'androidx.compose.foundation.gestures.legacyWheelDeltaX' : (event) => (event.wheelDeltaX == null) ? NaN : event.wheelDeltaX,
    'androidx.compose.foundation.gestures.legacyWheelDeltaY' : (event) => (event.wheelDeltaY == null) ? NaN : event.wheelDeltaY,
    'androidx.compose.foundation.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.foundation.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.foundation.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'org.jetbrains.compose.resources.Locale_$external_fun' : (p0) => new Intl.Locale(p0),
    'org.jetbrains.compose.resources.language_$external_prop_getter' : (_this) => _this.language,
    'org.jetbrains.compose.resources.script_$external_prop_getter' : (_this) => _this.script,
    'org.jetbrains.compose.resources.region_$external_prop_getter' : (_this) => _this.region,
    'org.jetbrains.compose.resources.jsExportBlobAsArrayBuffer' : (blob) => blob.arrayBuffer(),
    'org.jetbrains.compose.resources.copyArrayBufferToWasmMemory' : (wasmMemory, ab, ptr) => {
          const data = new Uint8Array(ab);
          new Uint8Array(wasmMemory.buffer).set(data, ptr);
    },
    'org.jetbrains.compose.resources.jsFetchWithSignal' : (url, signal) => window.fetch(url, { signal }),
    'org.jetbrains.compose.resources.AbortController_$external_fun' : () => new AbortController(),
    'org.jetbrains.compose.resources.signal_$external_prop_getter' : (_this) => _this.signal,
    'org.jetbrains.compose.resources.abort_$external_fun' : (_this, ) => _this.abort(),
    'org.jetbrains.compose.resources.supportsCacheApi' : () => Boolean(window.caches),
    'co.touchlab.kermit.consoleError' : (output) => console.error(output),
    'co.touchlab.kermit.consoleWarn' : (output) => console.warn(output),
    'co.touchlab.kermit.consoleInfo' : (output) => console.info(output),
    'co.touchlab.kermit.consoleLog' : (output) => console.log(output),
    'kotlinx.datetime.internal.Date_$external_fun' : (p0) => new Date(p0),
    'kotlinx.datetime.internal.getTimezoneOffset_$external_fun' : (_this, ) => _this.getTimezoneOffset(),
    'kotlinx.datetime.internal.JSJoda.ZoneRulesProvider_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneRulesProvider,
    'kotlinx.datetime.internal.JSJoda.id_$external_fun' : (_this, ) => _this.id(),
    'kotlinx.datetime.internal.JSJoda.systemDefault_$external_fun' : (_this, ) => _this.systemDefault(),
    'kotlinx.datetime.internal.JSJoda.Companion_$external_object_getInstance' : () => _ref_QGpzLWpvZGEvY29yZQ_.ZoneId,
    'kotlinx.datetime.internal.withCaughtJsException' : (body) => {
        try {
            body();
            return null;
        } catch(e) {
            return e;
        }
    },
    'kotlinx.datetime.internal.getExceptionMessage' : (jsException) => jsException.message,
    'kotlinx.datetime.internal.getZones' : (rulesProvider) => rulesProvider.getTzdbData().zones,
    'kotlinx.datetime.internal.getLinks' : (rulesProvider) => rulesProvider.getTzdbData().links,
    'androidx.compose.material3.internal.weakMap_js_code' : () => (new WeakMap()),
    'androidx.compose.material3.internal.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'androidx.compose.material3.internal.get_$external_fun' : (_this, p0) => _this.get(p0),
    'androidx.navigation.compose.internal.WeakRef_$external_fun' : (p0) => new WeakRef(p0),
    'androidx.navigation.compose.internal.deref_$external_fun' : (_this, ) => _this.deref(),
    'pt.holypassword.oriens.infrastructure.application.ads.observeWebPrivacyOptions' : 
        (callback) => {
            window.oriensPrivacy.observe((required) => {
                callback(required);
            });
        }
        ,
    'pt.holypassword.oriens.infrastructure.application.ads.showWebPrivacyOptions' : 
        () => {
            window.oriensPrivacy.show();
        }
        ,
    'pt.holypassword.oriens.infrastructure.application.analytics.createUserProperty' : (name, value) => ({ [name]: value }),
    'pt.holypassword.oriens.infrastructure.application.analytics.isJsTruthy' : (value) => Boolean(value),
    'pt.holypassword.oriens.infrastructure.application.analytics.createAnalyticsSettings' : () => ({ config: { send_page_view: false } }),
    'pt.holypassword.oriens.infrastructure.application.analytics.createJsObject' : () => ({}),
    'pt.holypassword.oriens.infrastructure.application.analytics.setJsString' : (target, key, value) => { target[key] = value; },
    'pt.holypassword.oriens.infrastructure.application.analytics.setJsNumber' : (target, key, value) => { target[key] = value; },
    'pt.holypassword.oriens.infrastructure.application.messaging.onBrowserNotificationClick' : 
    (callback) => {
        if (!('serviceWorker' in navigator)) {
            return;
        }

        navigator.serviceWorker.addEventListener('message', event => {
            const data = event.data || {};
            if (data.type === 'ORIENS_NOTIFICATION_CLICK' && data.circleId) {
                callback(String(data.circleId));
            }
        });
    }
    ,
    'pt.holypassword.oriens.infrastructure.application.messaging.notificationPermission' : () => (typeof Notification !== 'undefined' ? Notification.permission : 'unsupported'),
    'pt.holypassword.oriens.infrastructure.application.messaging.requestNotificationPermission' : () => (typeof Notification !== 'undefined' ? Notification.requestPermission() : Promise.resolve('unsupported')),
    'pt.holypassword.oriens.infrastructure.application.share.isNativeShareAvailable' : () => typeof navigator.share === 'function',
    'pt.holypassword.oriens.infrastructure.application.share.copyToClipboard' : (text) => { if (navigator.clipboard) { navigator.clipboard.writeText(text); } },
    'pt.holypassword.oriens.infrastructure.application.share.browserNavigator' : () => navigator,
    'pt.holypassword.oriens.infrastructure.application.share.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'pt.holypassword.oriens.infrastructure.application.share.text_$external_prop_setter' : (_this, v) => _this.text = v,
    'pt.holypassword.oriens.infrastructure.application.share.share_$external_fun' : (_this, p0) => _this.share(p0),
    'pt.holypassword.oriens.infrastructure.firebase.invokeDeleteAccount' : (callable, expectedUserId) => callable({confirm: true, expectedUserId}),
    'pt.holypassword.oriens.infrastructure.firebase.deletionStatus' : (result) => result && result.data && typeof result.data.status === 'string' ? result.data.status : null,
    'pt.holypassword.oriens.infrastructure.firebase.logEvent_$external_fun' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.logEvent(p0, p1, p2),
    'pt.holypassword.oriens.infrastructure.firebase.setUserProperties_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.setUserProperties(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.setUserId_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.setUserId(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.setAnalyticsCollectionEnabled_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.setAnalyticsCollectionEnabled(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.isSupported_$external_fun' : () => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.isSupported(),
    'pt.holypassword.oriens.infrastructure.firebase.initializeAnalytics_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYW5hbHl0aWNz_.initializeAnalytics(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.jsValueToString' : (value) => String(value),
    'pt.holypassword.oriens.infrastructure.firebase.getJsErrorCode' : (error) => (error && error.code) ? String(error.code) : null,
    'pt.holypassword.oriens.infrastructure.firebase.getJsErrorMessage' : (error) => (error && error.message) ? String(error.message) : null,
    'pt.holypassword.oriens.infrastructure.firebase.initializeApp_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYXBw_.initializeApp(p0),
    'pt.holypassword.oriens.infrastructure.firebase.currentUser_$external_prop_getter' : (_this) => _this.currentUser,
    'pt.holypassword.oriens.infrastructure.firebase.getAuth_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYXV0aA_.getAuth(p0),
    'pt.holypassword.oriens.infrastructure.firebase.uid_$external_prop_getter' : (_this) => _this.uid,
    'pt.holypassword.oriens.infrastructure.firebase.isAnonymous_$external_prop_getter' : (_this) => _this.isAnonymous,
    'pt.holypassword.oriens.infrastructure.firebase.email_$external_prop_getter' : (_this) => _this.email,
    'pt.holypassword.oriens.infrastructure.firebase.displayName_$external_prop_getter' : (_this) => _this.displayName,
    'pt.holypassword.oriens.infrastructure.firebase.user_$external_prop_getter' : (_this) => _this.user,
    'pt.holypassword.oriens.infrastructure.firebase.reauthenticateWithPopup_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.reauthenticateWithPopup(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.GoogleAuthProvider_$external_fun' : () => new _ref_ZmlyZWJhc2UvYXV0aA_.GoogleAuthProvider(),
    'pt.holypassword.oriens.infrastructure.firebase.getIdToken_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.getIdToken(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.onAuthStateChanged_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.onAuthStateChanged(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.signInAnonymously_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYXV0aA_.signInAnonymously(p0),
    'pt.holypassword.oriens.infrastructure.firebase.signOut_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYXV0aA_.signOut(p0),
    'pt.holypassword.oriens.infrastructure.firebase.linkWithRedirect_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.linkWithRedirect(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.signInWithRedirect_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvYXV0aA_.signInWithRedirect(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.getRedirectResult_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvYXV0aA_.getRedirectResult(p0),
    'pt.holypassword.oriens.infrastructure.firebase.id_$external_prop_setter' : (_this, v) => _this.id = v,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_setter' : (_this, v) => _this.circleId = v,
    'pt.holypassword.oriens.infrastructure.firebase.token_$external_prop_setter' : (_this, v) => _this.token = v,
    'pt.holypassword.oriens.infrastructure.firebase.message_$external_prop_setter' : (_this, v) => _this.message = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdBy_$external_prop_setter' : (_this, v) => _this.createdBy = v,
    'pt.holypassword.oriens.infrastructure.firebase.type_$external_prop_setter' : (_this, v) => _this.type = v,
    'pt.holypassword.oriens.infrastructure.firebase.status_$external_prop_setter' : (_this, v) => _this.status = v,
    'pt.holypassword.oriens.infrastructure.firebase.usageCount_$external_prop_setter' : (_this, v) => _this.usageCount = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_setter' : (_this, v) => _this.updatedAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.token_$external_prop_setter_1' : (_this, v) => _this.token = v,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_setter_1' : (_this, v) => _this.circleId = v,
    'pt.holypassword.oriens.infrastructure.firebase.inviteId_$external_prop_setter' : (_this, v) => _this.inviteId = v,
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_getter' : (_this) => _this.userId,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_getter' : (_this) => _this.circleId,
    'pt.holypassword.oriens.infrastructure.firebase.membershipType_$external_prop_getter' : (_this) => _this.membershipType,
    'pt.holypassword.oriens.infrastructure.firebase.isActive_$external_prop_getter' : (_this) => _this.isActive,
    'pt.holypassword.oriens.infrastructure.firebase.joinedByInviteId_$external_prop_getter' : (_this) => _this.joinedByInviteId,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_setter' : (_this, v) => _this.userId = v,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_setter_2' : (_this, v) => _this.circleId = v,
    'pt.holypassword.oriens.infrastructure.firebase.membershipType_$external_prop_setter' : (_this, v) => _this.membershipType = v,
    'pt.holypassword.oriens.infrastructure.firebase.isActive_$external_prop_setter' : (_this, v) => _this.isActive = v,
    'pt.holypassword.oriens.infrastructure.firebase.joinedByInviteId_$external_prop_setter' : (_this, v) => _this.joinedByInviteId = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter_1' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_setter_1' : (_this, v) => _this.updatedAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_setter_1' : (_this, v) => _this.userId = v,
    'pt.holypassword.oriens.infrastructure.firebase.joinedAt_$external_prop_setter' : (_this, v) => _this.joinedAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.token_$external_prop_getter' : (_this) => _this.token,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_getter_1' : (_this) => _this.circleId,
    'pt.holypassword.oriens.infrastructure.firebase.inviteId_$external_prop_getter' : (_this) => _this.inviteId,
    'pt.holypassword.oriens.infrastructure.firebase.id_$external_prop_getter' : (_this) => _this.id,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_getter_2' : (_this) => _this.circleId,
    'pt.holypassword.oriens.infrastructure.firebase.token_$external_prop_getter_1' : (_this) => _this.token,
    'pt.holypassword.oriens.infrastructure.firebase.message_$external_prop_getter' : (_this) => _this.message,
    'pt.holypassword.oriens.infrastructure.firebase.createdBy_$external_prop_getter' : (_this) => _this.createdBy,
    'pt.holypassword.oriens.infrastructure.firebase.type_$external_prop_getter' : (_this) => _this.type,
    'pt.holypassword.oriens.infrastructure.firebase.status_$external_prop_getter' : (_this) => _this.status,
    'pt.holypassword.oriens.infrastructure.firebase.usageCount_$external_prop_getter' : (_this) => _this.usageCount,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_1' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_1' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.ownerUserId_$external_prop_setter' : (_this, v) => _this.ownerUserId = v,
    'pt.holypassword.oriens.infrastructure.firebase.name_$external_prop_setter' : (_this, v) => _this.name = v,
    'pt.holypassword.oriens.infrastructure.firebase.description_$external_prop_setter' : (_this, v) => _this.description = v,
    'pt.holypassword.oriens.infrastructure.firebase.visibility_$external_prop_setter' : (_this, v) => _this.visibility = v,
    'pt.holypassword.oriens.infrastructure.firebase.status_$external_prop_setter_1' : (_this, v) => _this.status = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter_2' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_setter_2' : (_this, v) => _this.updatedAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.ownerUserId_$external_prop_getter' : (_this) => _this.ownerUserId,
    'pt.holypassword.oriens.infrastructure.firebase.name_$external_prop_getter' : (_this) => _this.name,
    'pt.holypassword.oriens.infrastructure.firebase.description_$external_prop_getter' : (_this) => _this.description,
    'pt.holypassword.oriens.infrastructure.firebase.visibility_$external_prop_getter' : (_this) => _this.visibility,
    'pt.holypassword.oriens.infrastructure.firebase.status_$external_prop_getter_1' : (_this) => _this.status,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_2' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_2' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.getFirestore_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getFirestore(p0),
    'pt.holypassword.oriens.infrastructure.firebase.set_$external_fun' : (_this, p0, p1) => _this.set(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.commit_$external_fun' : (_this, ) => _this.commit(),
    'pt.holypassword.oriens.infrastructure.firebase.writeBatch_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.writeBatch(p0),
    'pt.holypassword.oriens.infrastructure.firebase.doc_$external_fun' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.doc(p0, p1, p2),
    'pt.holypassword.oriens.infrastructure.firebase.exists_$external_fun' : (_this, ) => _this.exists(),
    'pt.holypassword.oriens.infrastructure.firebase.data_$external_fun' : (_this, ) => _this.data(),
    'pt.holypassword.oriens.infrastructure.firebase.id_$external_prop_getter_1' : (_this) => _this.id,
    'pt.holypassword.oriens.infrastructure.firebase.getDoc_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDoc(p0),
    'pt.holypassword.oriens.infrastructure.firebase.docs_$external_prop_getter' : (_this) => _this.docs,
    'pt.holypassword.oriens.infrastructure.firebase.getDocs_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.getDocs(p0),
    'pt.holypassword.oriens.infrastructure.firebase.query_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.query(p0, ...p1),
    'pt.holypassword.oriens.infrastructure.firebase.collection_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.collection(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.orderBy_$external_fun' : (p0, p1, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.orderBy(p0, isDefault0 ? undefined : p1, ),
    'pt.holypassword.oriens.infrastructure.firebase.runTransaction_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.runTransaction(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.get_$external_fun' : (_this, p0) => _this.get(p0),
    'pt.holypassword.oriens.infrastructure.firebase.set_$external_fun_1' : (_this, p0, p1) => _this.set(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.delete_$external_fun' : (_this, p0) => _this.delete(p0),
    'pt.holypassword.oriens.infrastructure.firebase.Timestamp_$external_fun' : (p0, p1) => new _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.Timestamp(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.seconds_$external_prop_getter' : (_this) => _this.seconds,
    'pt.holypassword.oriens.infrastructure.firebase.nanoseconds_$external_prop_getter' : (_this) => _this.nanoseconds,
    'pt.holypassword.oriens.infrastructure.firebase.setDoc_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.setDoc(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.collectionGroup_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.collectionGroup(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.where_$external_fun' : (p0, p1, p2) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.where(p0, p1, p2),
    'pt.holypassword.oriens.infrastructure.firebase.onQuerySnapshot_$external_fun' : (p0, p1, p2, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.onSnapshot(p0, p1, isDefault0 ? undefined : p2, ),
    'pt.holypassword.oriens.infrastructure.firebase.onSnapshot_$external_fun' : (p0, p1, p2, isDefault0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.onSnapshot(p0, p1, isDefault0 ? undefined : p2, ),
    'pt.holypassword.oriens.infrastructure.firebase.limit_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.limit(p0),
    'pt.holypassword.oriens.infrastructure.firebase.deleteDoc_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.deleteDoc(p0),
    'pt.holypassword.oriens.infrastructure.firebase.serverTimestamp_$external_fun' : () => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.serverTimestamp(),
    'pt.holypassword.oriens.infrastructure.firebase.updateDoc_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZmlyZXN0b3Jl_.updateDoc(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.httpsCallable_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZnVuY3Rpb25z_.httpsCallable(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.getFunctions_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvZnVuY3Rpb25z_.getFunctions(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.isMessagingSupported_$external_fun' : () => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.isSupported(),
    'pt.holypassword.oriens.infrastructure.firebase.getMessaging_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.getMessaging(p0),
    'pt.holypassword.oriens.infrastructure.firebase.onRegistered_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.onRegistered(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.onUnregistered_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.onUnregistered(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.register_$external_fun' : (p0, p1) => _ref_ZmlyZWJhc2UvbWVzc2FnaW5n_.register(p0, p1),
    'pt.holypassword.oriens.infrastructure.firebase.vapidKey_$external_prop_setter' : (_this, v) => _this.vapidKey = v,
    'pt.holypassword.oriens.infrastructure.firebase.createFirebaseOptions' : (apiKey, authDomain, projectId, storageBucket, messagingSenderId, appId, measurementId) => ({ apiKey: apiKey, authDomain: authDomain, projectId: projectId, storageBucket: storageBucket, messagingSenderId: messagingSenderId, appId: appId, measurementId: measurementId }),
    'pt.holypassword.oriens.infrastructure.firebase.count_$external_prop_getter' : (_this) => _this.count,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter_3' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.count_$external_prop_setter' : (_this, v) => _this.count = v,
    'pt.holypassword.oriens.infrastructure.firebase.title_$external_prop_getter' : (_this) => _this.title,
    'pt.holypassword.oriens.infrastructure.firebase.sortTitle_$external_prop_getter' : (_this) => _this.sortTitle,
    'pt.holypassword.oriens.infrastructure.firebase.slug_$external_prop_getter' : (_this) => _this.slug,
    'pt.holypassword.oriens.infrastructure.firebase.categoryId_$external_prop_getter' : (_this) => _this.categoryId,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_3' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_3' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.title_$external_prop_getter_1' : (_this) => _this.title,
    'pt.holypassword.oriens.infrastructure.firebase.sortTitle_$external_prop_getter_1' : (_this) => _this.sortTitle,
    'pt.holypassword.oriens.infrastructure.firebase.slug_$external_prop_getter_1' : (_this) => _this.slug,
    'pt.holypassword.oriens.infrastructure.firebase.text_$external_prop_getter' : (_this) => _this.text,
    'pt.holypassword.oriens.infrastructure.firebase.shortDescription_$external_prop_getter' : (_this) => _this.shortDescription,
    'pt.holypassword.oriens.infrastructure.firebase.categoryId_$external_prop_getter_1' : (_this) => _this.categoryId,
    'pt.holypassword.oriens.infrastructure.firebase.language_$external_prop_getter' : (_this) => _this.language,
    'pt.holypassword.oriens.infrastructure.firebase.active_$external_prop_getter' : (_this) => _this.active,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_4' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_4' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.createFirestoreUserEmailDocument' : (userId) => ({ userId: userId }),
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_getter_1' : (_this) => _this.userId,
    'pt.holypassword.oriens.infrastructure.firebase.postId_$external_prop_setter' : (_this, v) => _this.postId = v,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_setter_3' : (_this, v) => _this.circleId = v,
    'pt.holypassword.oriens.infrastructure.firebase.authorId_$external_prop_setter' : (_this, v) => _this.authorId = v,
    'pt.holypassword.oriens.infrastructure.firebase.type_$external_prop_setter_1' : (_this, v) => _this.type = v,
    'pt.holypassword.oriens.infrastructure.firebase.status_$external_prop_setter_2' : (_this, v) => _this.status = v,
    'pt.holypassword.oriens.infrastructure.firebase.title_$external_prop_setter' : (_this, v) => _this.title = v,
    'pt.holypassword.oriens.infrastructure.firebase.message_$external_prop_setter_1' : (_this, v) => _this.message = v,
    'pt.holypassword.oriens.infrastructure.firebase.prayerId_$external_prop_setter' : (_this, v) => _this.prayerId = v,
    'pt.holypassword.oriens.infrastructure.firebase.prayerCount_$external_prop_setter' : (_this, v) => _this.prayerCount = v,
    'pt.holypassword.oriens.infrastructure.firebase.commentCount_$external_prop_setter' : (_this, v) => _this.commentCount = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter_4' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_setter_3' : (_this, v) => _this.updatedAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.postId_$external_prop_setter_1' : (_this, v) => _this.postId = v,
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_setter_2' : (_this, v) => _this.userId = v,
    'pt.holypassword.oriens.infrastructure.firebase.type_$external_prop_setter_2' : (_this, v) => _this.type = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter_5' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.postId_$external_prop_getter' : (_this) => _this.postId,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_getter_3' : (_this) => _this.circleId,
    'pt.holypassword.oriens.infrastructure.firebase.authorId_$external_prop_getter' : (_this) => _this.authorId,
    'pt.holypassword.oriens.infrastructure.firebase.type_$external_prop_getter_1' : (_this) => _this.type,
    'pt.holypassword.oriens.infrastructure.firebase.status_$external_prop_getter_2' : (_this) => _this.status,
    'pt.holypassword.oriens.infrastructure.firebase.title_$external_prop_getter_2' : (_this) => _this.title,
    'pt.holypassword.oriens.infrastructure.firebase.message_$external_prop_getter_1' : (_this) => _this.message,
    'pt.holypassword.oriens.infrastructure.firebase.prayerId_$external_prop_getter' : (_this) => _this.prayerId,
    'pt.holypassword.oriens.infrastructure.firebase.prayerCount_$external_prop_getter' : (_this) => _this.prayerCount,
    'pt.holypassword.oriens.infrastructure.firebase.commentCount_$external_prop_getter' : (_this) => _this.commentCount,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_5' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_5' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.postId_$external_prop_getter_1' : (_this) => _this.postId,
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_getter_2' : (_this) => _this.userId,
    'pt.holypassword.oriens.infrastructure.firebase.type_$external_prop_getter_2' : (_this) => _this.type,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_6' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.title_$external_prop_getter_3' : (_this) => _this.title,
    'pt.holypassword.oriens.infrastructure.firebase.contents_$external_prop_getter' : (_this) => _this.contents,
    'pt.holypassword.oriens.infrastructure.firebase.referenceId_$external_prop_getter' : (_this) => _this.referenceId,
    'pt.holypassword.oriens.infrastructure.firebase.source_$external_prop_getter' : (_this) => _this.source,
    'pt.holypassword.oriens.infrastructure.firebase.locale_$external_prop_getter' : (_this) => _this.locale,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_7' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_6' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.book_$external_prop_getter' : (_this) => _this.book,
    'pt.holypassword.oriens.infrastructure.firebase.passages_$external_prop_getter' : (_this) => _this.passages,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_8' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_7' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.chapter_$external_prop_getter' : (_this) => _this.chapter,
    'pt.holypassword.oriens.infrastructure.firebase.startVerse_$external_prop_getter' : (_this) => _this.startVerse,
    'pt.holypassword.oriens.infrastructure.firebase.endVerse_$external_prop_getter' : (_this) => _this.endVerse,
    'pt.holypassword.oriens.infrastructure.firebase.verse_$external_prop_getter' : (_this) => _this.verse,
    'pt.holypassword.oriens.infrastructure.firebase.part_$external_prop_getter' : (_this) => _this.part,
    'pt.holypassword.oriens.infrastructure.firebase.calendar_$external_prop_getter' : (_this) => _this.calendar,
    'pt.holypassword.oriens.infrastructure.firebase.referenceId_$external_prop_getter_1' : (_this) => _this.referenceId,
    'pt.holypassword.oriens.infrastructure.firebase.date_$external_prop_getter' : (_this) => _this.date,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_9' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_8' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.notificationId_$external_prop_setter' : (_this, v) => _this.notificationId = v,
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_setter_3' : (_this, v) => _this.userId = v,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_setter_4' : (_this, v) => _this.circleId = v,
    'pt.holypassword.oriens.infrastructure.firebase.postId_$external_prop_setter_2' : (_this, v) => _this.postId = v,
    'pt.holypassword.oriens.infrastructure.firebase.title_$external_prop_setter_1' : (_this, v) => _this.title = v,
    'pt.holypassword.oriens.infrastructure.firebase.message_$external_prop_setter_2' : (_this, v) => _this.message = v,
    'pt.holypassword.oriens.infrastructure.firebase.viewed_$external_prop_setter' : (_this, v) => _this.viewed = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter_6' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_setter_4' : (_this, v) => _this.updatedAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.notificationId_$external_prop_getter' : (_this) => _this.notificationId,
    'pt.holypassword.oriens.infrastructure.firebase.userId_$external_prop_getter_3' : (_this) => _this.userId,
    'pt.holypassword.oriens.infrastructure.firebase.circleId_$external_prop_getter_4' : (_this) => _this.circleId,
    'pt.holypassword.oriens.infrastructure.firebase.postId_$external_prop_getter_2' : (_this) => _this.postId,
    'pt.holypassword.oriens.infrastructure.firebase.title_$external_prop_getter_4' : (_this) => _this.title,
    'pt.holypassword.oriens.infrastructure.firebase.message_$external_prop_getter_2' : (_this) => _this.message,
    'pt.holypassword.oriens.infrastructure.firebase.viewed_$external_prop_getter' : (_this) => _this.viewed,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_10' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_9' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.createFirestoreUserDocument' : (name, email, onboardingComplete, preferredLanguage, createdAt, updatedAt) => ({
            name: name,
            email: email,
            onboardingComplete: onboardingComplete,
            preferredLanguage: preferredLanguage,
            createdAt: createdAt,
            updatedAt: updatedAt
        }),
    'pt.holypassword.oriens.infrastructure.firebase.name_$external_prop_getter_1' : (_this) => _this.name,
    'pt.holypassword.oriens.infrastructure.firebase.email_$external_prop_getter_1' : (_this) => _this.email,
    'pt.holypassword.oriens.infrastructure.firebase.onboardingComplete_$external_prop_getter' : (_this) => _this.onboardingComplete,
    'pt.holypassword.oriens.infrastructure.firebase.preferredLanguage_$external_prop_getter' : (_this) => _this.preferredLanguage,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_11' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_10' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.createFirestoreUserInfoDocument' : (themeMode, consecutiveDaysCount, prayersReadCount, lastLoginAt) => ({
            themeMode: themeMode,
            consecutiveDaysCount: consecutiveDaysCount,
            prayersReadCount: prayersReadCount,
            lastLoginAt: lastLoginAt
        }),
    'pt.holypassword.oriens.infrastructure.firebase.themeMode_$external_prop_getter' : (_this) => _this.themeMode,
    'pt.holypassword.oriens.infrastructure.firebase.consecutiveDaysCount_$external_prop_getter' : (_this) => _this.consecutiveDaysCount,
    'pt.holypassword.oriens.infrastructure.firebase.prayersReadCount_$external_prop_getter' : (_this) => _this.prayersReadCount,
    'pt.holypassword.oriens.infrastructure.firebase.lastLoginAt_$external_prop_getter' : (_this) => _this.lastLoginAt,
    'pt.holypassword.oriens.infrastructure.firebase.platform_$external_prop_setter' : (_this, v) => _this.platform = v,
    'pt.holypassword.oriens.infrastructure.firebase.pushEnabled_$external_prop_setter' : (_this, v) => _this.pushEnabled = v,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_setter_7' : (_this, v) => _this.createdAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_setter_5' : (_this, v) => _this.updatedAt = v,
    'pt.holypassword.oriens.infrastructure.firebase.platform_$external_prop_getter' : (_this) => _this.platform,
    'pt.holypassword.oriens.infrastructure.firebase.pushEnabled_$external_prop_getter' : (_this) => _this.pushEnabled,
    'pt.holypassword.oriens.infrastructure.firebase.createdAt_$external_prop_getter_12' : (_this) => _this.createdAt,
    'pt.holypassword.oriens.infrastructure.firebase.updatedAt_$external_prop_getter_11' : (_this) => _this.updatedAt,
    'pt.holypassword.oriens.infrastructure.firebase.createFirestoreUserInteractionsDocument' : (prayedForPrayerRequestIds, savedPrayersIds) => ({
            prayedForPrayerRequestIds: prayedForPrayerRequestIds,
            savedPrayersIds: savedPrayersIds
        }),
    'pt.holypassword.oriens.infrastructure.firebase.prayedForPrayerRequestIds_$external_prop_getter' : (_this) => _this.prayedForPrayerRequestIds,
    'pt.holypassword.oriens.infrastructure.firebase.savedPrayersIds_$external_prop_getter' : (_this) => _this.savedPrayersIds,
    'pt.holypassword.oriens.infrastructure.firebase.createJsObject' : () => ({}),
    'pt.holypassword.oriens.infrastructure.firebase.dto.createThemeUpdateDocument' : (themeMode) => ({
            themeMode: themeMode
        }),
    'pt.holypassword.oriens.infrastructure.firebase.installations.getInstallations_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvaW5zdGFsbGF0aW9ucw_.getInstallations(p0),
    'pt.holypassword.oriens.infrastructure.firebase.installations.getId_$external_fun' : (p0) => _ref_ZmlyZWJhc2UvaW5zdGFsbGF0aW9ucw_.getId(p0),
    'pt.holypassword.oriens.ui.components.writeDismissedAt' : (timestamp) => {
            try { window.localStorage.setItem('oriens.getAppBanner.dismissedAt', String(timestamp)); } catch (e) {}
        },
    'pt.holypassword.oriens.ui.components.nowMs' : () => Date.now(),
    'pt.holypassword.oriens.ui.components.isAndroidBrowser' : () => (function() {
            try {
                var standalone = window.matchMedia && window.matchMedia('(display-mode: standalone)').matches;
                return /Android/i.test(navigator.userAgent) && !standalone;
            } catch (e) { return false; }
        })(),
    'pt.holypassword.oriens.ui.components.readDismissedAt' : () => (function() {
            try {
                var v = parseFloat(window.localStorage.getItem('oriens.getAppBanner.dismissedAt'));
                return isNaN(v) ? 0 : v;
            } catch (e) { return 0; }
        })(),
    'pt.holypassword.oriens.ui.components.requestAdSenseAd' : () => 
        {
            window.requestAnimationFrame(() => {
                try {
                    (window.adsbygoogle = window.adsbygoogle || []).push({});
                } catch (error) {
                    console.error("Oriens AdSense request failed", error);
                }
            });
        }
        ,
    'pt.holypassword.oriens.ui.platform.openBrowserTab' : (url) => { window.open(url, '_blank', 'noopener,noreferrer'); },
    'coil3.decode.blob' : (code) => new Blob([code], { type: 'application/javascript' })
}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export { wasmTag as __TAG };

export const importObject = {
    js_code,
    intrinsics: {
        memory: new WebAssembly.Memory({ initial: 0 }),
        tag: wasmTag
    },
    "'": StringConstantsProxy,
    'wasm:js-string': d2FzbTpqcy1zdHJpbmc,
    './skiko.mjs': Li9za2lrby5tanM,
};
    